<template>
    <div>
        <nodata-for-detail title="暂未填写急救日志" v-if="list.length===0">
            <div class="flex jcc mt5" v-if="isAID_ADM">
                <el-button type="primary" size="mini" @click="$refs.add.show({
            emergencyReferralOrderId:id
            })">
                    新增日志
                </el-button>
            </div>
        </nodata-for-detail>
        <ul v-else>
            <li v-for="(item,index) in list" :key="index">
                <h3 class="flex">
                    <span>{{item.loggingTime|timeFilter('YYYY/MM/DD HH:mm')}}</span>
                    <span
                            class="fs14 ml15 flex1">（{{item.hosName}} {{item.creatorTypeDesc}} {{item.creatorName}}添加）</span>
                    <div v-if="item.creatorId===loginInfo.id">
                        <el-button size="mini" type="text" @click="modify(item)">修改</el-button>
                        <el-button size="mini" type="text" style="color:red;" @click="del(item)">删除</el-button>
                    </div>
                </h3>
                <el-row class="fs14">
                    <el-col :span="6">心率：{{item.heartRate?item.heartRate+'次/min':''}}</el-col>
                    <el-col :span="6">
                        血压：{{item.bloodPressureUpper||item.bloodPressureLower?item.bloodPressureUpper+'/'+item.bloodPressureLower+'mmHg':''}}
                    </el-col>
                    <el-col :span="6">氧饱和度：{{item.oxygenSaturation?item.oxygenSaturation+'%':''}}</el-col>
                    <el-col :span="6">呼吸频率：{{item.respiratoryRate?item.respiratoryRate+'次/min':''}}</el-col>
                </el-row>
                <div class="mt15 fs14">
                    {{item.treatmentProcess}}
                </div>
                <div class="mt15">
                    <el-image :src="data.url" style="width: 60px; height: 60px; margin-right: 15px"
                              v-for="(data,idx) in item.attaList"
                              :key="idx"
                              :preview-src-list="[data.url]"
                    ></el-image>
                </div>
            </li>
        </ul>
        <div class="flex jcc" v-if="list.length">
            <el-button type="primary" size="mini" @click="$refs.add.show({
            emergencyReferralOrderId:id
            })" v-if="isAID_ADM">
                新增日志
            </el-button>
        </div>
        <add-record-dialog ref="add" @ok="getList"></add-record-dialog>
    </div>
</template>

<script>
    import {staffService} from "../service/staff";
    import {timeFilter} from "../../../common/lib/filters";
    import AddRecordDialog from "./add-record-dialog";
    import NodataForDetail from "./nodata-for-detail";

    export default {
        name: "record-form",
        components: {NodataForDetail, AddRecordDialog},
        filters: {timeFilter},
        props: {
            id: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                page: {},
                list: []
            }
        },
        created() {
            this.getList();
        },
        methods: {
            modify(data) {
                this.$refs.add.show(data);
            },
            del(data) {
                this.$confirm(`是否删除该日志?`)
                    .then(async () => {
                        if (await staffService.deleteRecord(data.id)) {
                            this.$message.success('删除成功!');
                            this.getList();
                        }
                    })
            },
            async getList() {
                const {list, page} = await staffService.listRecord(this.id);
                this.list = list;
                this.page = page;
            }
        },
    }
</script>

<style scoped>
    li + li {
        margin-top: 15px;
    }
</style>
